import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles, Wrench, Zap, Home, Hammer } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

const iconMap = {
  Sparkles,
  Wrench,
  Zap,
  ChefHat: Home,
  Home,
  Hammer
};

const ServiceCard = ({ service, index }) => {
  const Icon = iconMap[service.icon] || Sparkles;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Card className="group relative overflow-hidden bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
        {/* Icon Background */}
        <div className="mb-4 w-14 h-14 bg-gradient-to-br from-teal-100 to-green-100 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <Icon className="w-7 h-7 text-teal-600" />
        </div>

        {/* Content */}
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          {service.title}
        </h3>
        <p className="text-gray-600 mb-4 text-sm leading-relaxed">
          {service.description}
        </p>

        {/* Features */}
        <div className="mb-4">
          <ul className="space-y-1">
            {service.features.slice(0, 3).map((feature, idx) => (
              <li key={idx} className="text-sm text-gray-500 flex items-center">
                <span className="w-1.5 h-1.5 bg-teal-500 rounded-full mr-2"></span>
                {feature}
              </li>
            ))}
          </ul>
        </div>

        {/* Price and CTA */}
        <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-100">
          <div>
            <span className="text-sm text-gray-500">Starting at</span>
            <p className="text-xl font-semibold text-teal-600">{service.startingPrice}</p>
          </div>
          <Button
            variant="ghost"
            className="text-teal-600 hover:text-teal-700 group-hover:translate-x-1 transition-transform"
          >
            Book Now
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>

        {/* Hover Effect Border */}
        <div className="absolute inset-0 border-2 border-teal-500 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
      </Card>
    </motion.div>
  );
};

export default ServiceCard;
